import { isEmptyObject, isNullOrUndefined } from '@as-react/common-utils';
class SelectorUtil {
    static getSelectedColor(product) {
        if (isNullOrUndefined(product) || isNullOrUndefined(product.productColorVariations)) {
            return null;
        }
        return product.productColorVariations.find(productColorVariation => productColorVariation.colorId === product.selectedColorId);
    }
    static getSelectedSku(product, selectedColor) {
        return selectedColor.sizes.find(size => size.sku === product.selectedSku);
    }
    static getAvailableColors(product) {
        return product.productColorVariations.filter((productColor) => productColor.active &&
            productColor.visible &&
            (productColor.availability > 0 || productColor.colorId === product.selectedColorId));
    }
    static getPriceInformation(product, colorVariation) {
        if (isNullOrUndefined(product) || isEmptyObject(product) || isNullOrUndefined(colorVariation))
            return null;
        if (!isNullOrUndefined(product.selectedSku)) {
            const colorVariationSize = SelectorUtil.getSelectedSku(product, colorVariation);
            if (!isNullOrUndefined(colorVariationSize) && !isNullOrUndefined(colorVariationSize.prices)) {
                return {
                    hasDiscount: Boolean(colorVariation.hasDiscount),
                    prices: colorVariationSize.prices,
                };
            }
        }
        return {
            hasDiscount: Boolean(colorVariation.hasDiscount),
            prices: colorVariation.prices,
        };
    }
    static getDynamicSavingsInformation(product, colorVariation) {
        if (!isNullOrUndefined(product.selectedSku)) {
            const colorVariationSize = SelectorUtil.getSelectedSku(product, colorVariation);
            if (!isNullOrUndefined(colorVariationSize)) {
                return {
                    productDiscountPercentage: Number(colorVariationSize.productDiscountPercentage),
                    productDiscountAmount: Number(colorVariationSize.productDiscountAmount),
                };
            }
        }
        return {
            productDiscountPercentage: colorVariation.colourDiscountPercentage,
            productDiscountAmount: colorVariation.colourDiscountAmount,
        };
    }
}
export default SelectorUtil;
